import { Licenses } from '@varo/graphql-schema-types';
import TabaPayLicense from 'services/graphql/queries/MoveMoney/TabaPayLicense';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

interface TabaPayLicenses {
  licenses: Licenses;
}

export const useTabaPayLicense = () => {
  const [{ data, fetching, error }] = useQuery<TabaPayLicenses>({
    query: TabaPayLicense,
    requestPolicy: 'cache-first',
    variables: { version: '' },
  });

  const responseError = useFormattedCombinedError(error);

  const errorModel = responseError
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: responseError.title,
        messageBody: responseError.message,
        primaryButton: undefined,
        secondaryButton: undefined,
        is3DSError: false,
        analytics: undefined,
      }
    : null;

  const key = data?.licenses?.web?.tabaPay?.key;
  return {
    tabaPayKey: typeof key === 'string' ? key : null,
    fetching,
    errorModel,
  };
};
